<a
    class="link-button"
    href="#"
    (click)="onClick($event)"
    [ngbTooltip]="tooltip"
    [disableTooltip]="userAgentService.isOnMobileDevice"
>
    <app-icon *ngIf="icon" [type]="icon" class="link-button-icon"></app-icon>
    <ng-content></ng-content>
    <div
        class="link-button-label"
        [ngClass]="{
            'hidden-on-tablet': hideLabelOnTablet,
            'hidden-on-small-devices': hideLabelOnSmallDevices,
            'hidden-on-mobile': hideLabelOnMobile
        }"
    >
        {{ label }}
    </div>
</a>
